const RoleTypes = {
    ADMIN:"admin",
    APPROVER:"approver",
    VERIFIER:"verifier",
    MANAGER:"manager"
}
export default RoleTypes;